import React, { Component } from "react";
import { Row, Col, Skeleton, Card, Button, message, Divider, Icon, Select } from "antd";
import UserActivitiesCard from "./parts/EA_And_LSP/UserActivityCard";
import Activity_card from "./parts/EA_And_LSP/ActivityCard";
import EaDashboardChart from "./parts/EA_And_LSP/EaDashboardCharts";
import EaProfileFilter from "./parts/EA_And_LSP/EaProfileFilter";
import axios from "axios";
import F from "../../Functions";
import moment from "moment";
import EaDateFilter from "./parts/EA_And_LSP/DateFilter";
import filter from "../../assets/icons/dashboard/filter.svg";
import { AGENCY_MANAGER, EA, SUPER_ADMIN } from "../../utils/Constants";
import CommonHeader from "./CommonHeader";
import BadPhoneNumber from "../../assets/phone-number.png";
import { COMBINED_COMPLETED_RAC_COUNT, GET_AM_ASSOCIATED_AGENCIES, GET_AM_DASH_BAD_PHONE_NUMBER_COUNT, GET_AM_DASHBOARD_STATS, GET_AM_DASH_GET_COMPLETED_HISTORY_COUNT, GET_AM_DASH_THREE_CARDS_STAT, GET_AM_DASH_ACTIVE_CALL_COUNT, GET_AM_DASH_OPPORTUNIY_BTN_CLICK, GET_AM_DASH_LEAD_APPOINTMENT_BTN_CLICK, GET_AM_DASH_REVIEW_APPOINTMENT_BTN_CLICK, CUSTOMER_UPLOAD_LIVE_STAT_TOTAL, CUSTOMER_UPLOAD_LIVE_STAT_MONTHLY } from "../../utils/Api_enums";
import { Translate } from "react-translated";
import { useBoundStore } from '../../store/useBoundStore';
import './AMDashboard.css';

const Option = Select.Option;
const today = new Date();

class AMDashboard extends Component {
    constructor(props) {
        super(props);
        // Default values

        //commentted due to old date picker implementation
        const defaultStartDate = "2010-01-01";
        const defaultEndDate = "2050-01-01";

        const defaultPeriod = "from_to";

        //implemented due to new date picker implementation
        let start_date = moment().startOf("month").format("YYYY-MM-DD");
        let end_date = moment().endOf("month").format("YYYY-MM-DD");

        // commented due to new date picker implementation
        // let start_date = moment(defaultStartDate).format("YYYY-MM-DD");
        // let end_date = moment(defaultEndDate).format("YYYY-MM-DD");

        let period = defaultPeriod;
        const myDateObj = localStorage.getItem("dateObj");
        if (myDateObj) {
            try {
                const parsedDateObj = JSON.parse(myDateObj);
                start_date = moment(parsedDateObj.start_date).format(
                    "YYYY-MM-DD"
                );
                end_date = moment(parsedDateObj.end_date).format(
                    "YYYY-MM-DD"
                );
                period = parsedDateObj.period;
            } catch (error) {
                console.error("Error parsing dateObj from localStorage:", error);
            }
        }

        this.state = {
            isAllBfiles: useBoundStore.getState().AMDashboardFilter.isAllBfiles,
            selectedAgency: useBoundStore.getState().AMDashboardFilter.agency_id,
            collapsed: this.props.collapsed,
            loadingChart: true,
            loadingStats: true,
            loading: true,
            dashboard: {
                lsp: [],
                vo_stats: {
                    FollowUp: {},
                    Prospect: {},
                },
                stats: {},
                card_data: {},
            },
            period: period,
            start_date: start_date,
            end_date: end_date,
            associations: [],
            user: this.props.auth.user,
            user_type: this.props.auth.user.user_type,
            vonboard: 1,
            review: 1,
            colSpan: 8,
            is_lead: 1,
            is_opportunity: 1,
            show_lead_card_appointment_details: 1,
            user_t: localStorage.getItem('user_t') || "",
            filter_lsp: localStorage.getItem('filter_lsp') || "",
            internalFilterChange: false,
            has_rs: false,
            agency_id: null,
            agency: {},
            bfiles_counts: {
                leads: 0,
                opportunity: 0,
                review: 0,
            },
            badPhoneNumber: 0,
            agencies: [],
        };
    }

    componentDidMount = () => {

        this.unsubscribe = useBoundStore.subscribe((state) => {
            this.setState({ selectedAgency: state.AMDashboardFilter.agency_id });
        });

        this.getAssociatedAgencyAM()
    };


    componentWillUnmount() {
        this.unsubscribe();
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedAgency !== this.state.selectedAgency) {
            this.loadAdditionalData();
        }
    }

    getAssociatedAgencyAM = async () => {
        try {
            this.setState({ agencies: [], loading: true });
            await this.fetchAssociatedAgencies();
            // const agency_id =
            // if (!agency_id) return;
            // if (agency_id) await this.fetchAgencyDetails(agency_id);
            await this.loadAdditionalData();

        } catch (error) {
            console.error("Error in getAssociatedAgencyAM:", error);
        } finally {
            this.setState({ loading: false });
        }
    };


    //new picker impl
    fetchAssociatedAgencies = async () => {
        try {
            const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${this.state.user.id}`);

            if (res.data && res.data.length > 0) {
                const agencies = res.data;

                const store = useBoundStore.getState();
                const selectedAgencyId = store.AMDashboardFilter.agency_id;
                const selectedDate = store.AMDashboardFilter.datemodified;
                const existingIsDateRangeClicked = Boolean(store.AMDashboardFilter.isDateRangeClicked);

                let start_date, end_date;
                let isDateRangeClicked = existingIsDateRangeClicked;
                let period = this.state.period;

                // Retain date picker selection when returning from grid (same as EaDashboards)
                let parsedDateObj = null;
                const myDateObj = localStorage.getItem("dateObj");
                if (myDateObj) {
                    try {
                        parsedDateObj = JSON.parse(myDateObj);
                    } catch (error) {
                        console.error("Error parsing dateObj from localStorage:", error);
                    }
                }

                if (parsedDateObj && parsedDateObj.start_date && parsedDateObj.end_date) {
                    start_date = moment(parsedDateObj.start_date).format("YYYY-MM-DD");
                    end_date = moment(parsedDateObj.end_date).format("YYYY-MM-DD");
                    period = parsedDateObj.period || period;
                    isDateRangeClicked = true;
                } else if (
                    existingIsDateRangeClicked &&
                    selectedDate &&
                    selectedDate.start_date &&
                    selectedDate.end_date
                ) {
                    start_date = moment(selectedDate.start_date).format("YYYY-MM-DD");
                    end_date = moment(selectedDate.end_date).format("YYYY-MM-DD");
                    isDateRangeClicked = true;
                } else if (selectedDate && selectedDate.start_date) {
                    start_date = moment(selectedDate.start_date || '2010-01-01').format("YYYY-MM-DD");
                    end_date = moment(selectedDate.end_date || '2050-01-01').format("YYYY-MM-DD");
                }

                // fallback ONLY if no retained / selected date
                if (!start_date) {
                    const oldestAgency = F.getOldestAgency(agencies);

                    if (oldestAgency) {
                        start_date = moment(oldestAgency.start_date || '2010-01-01').format("YYYY-MM-DD");
                        end_date = moment().format("YYYY-MM-DD");
                    } else {
                        start_date = moment().startOf("month").format("YYYY-MM-DD");
                        end_date = moment().endOf("month").format("YYYY-MM-DD");
                    }
                    isDateRangeClicked = false;
                }

                this.setState({
                    agencies,
                    start_date,
                    end_date,
                    period,
                    selectedAgency: selectedAgencyId || null
                });

                useBoundStore.getState().setAMDashboardFilter({
                    datemodified: {
                        start_date: start_date || "2010-01-01",
                        end_date: end_date || moment().format("YYYY-MM-DD")
                    },
                    isDateRangeClicked,
                });

            } else {
                this.setState({
                    agencies: [],
                    start_date: moment().startOf("month").format("YYYY-MM-DD"),
                    end_date: moment().endOf("month").format("YYYY-MM-DD")
                });
            }

        } catch (error) {
            console.error("Error fetching associated agencies:", error);
        }
    };

    //old picker impl
    // fetchAssociatedAgencies = async () => {
    //     try {
    //         const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${this.state.user.id}`);
    //         if (res.data && res.data.length > 0) {
    //             // const agency_id = res.data[0].agency_id;
    //             this.setState({ agencies: res.data });
    //             // return agency_id;
    //         } else {
    //             return null;
    //         }
    //     } catch (error) {
    //         console.error("Error fetching associated agencies:", error);
    //     }
    //     return null;
    // };


    fetchAgencyDetails = async (value) => {
        const zustandState = useBoundStore.getState().AMDashboardFilter;
        const selectedAgency = zustandState.agency_id;
        try {
            const res = await axios.get(`/api/agencies/${value}`);
            const activeCards = [
                res.data.review === 1,
                // res.data.is_lead === 1
                res.data.show_lead_card_appointment_details === 1,
                res.data.is_opportunity === 1,
            ].filter(Boolean).length;
            this.setState({
                vonboard: res.data.vonboard,
                review: res.data.review,
                active: res.data.active,
                is_lead: res.data.is_lead,
                is_opportunity: res.data.is_opportunity,
                show_lead_card_appointment_details: res.data.show_lead_card_appointment_details,
                agency: res.data,
                colSpan: activeCards > 0 ? Math.floor(24 / activeCards) : 24
            });
        } catch (error) {
            console.error("Error fetching agency details:", error);
        }
    };


    loadAdditionalData = async () => {
        try {
            await this.call_appointment_count();
            await this.loadCardData();
            await this.loadAMStats();
        } catch (error) {
            console.error("Error loading additional data:", error);
        }
    };



    call_appointment_count = async () => {
        const { agency_id, isAllBfiles, start_date, end_date } = this.state;
        const zustandState = useBoundStore.getState().AMDashboardFilter;
        const selectedAgency = zustandState.agency_id;

        this.setState({ loadingChart: true });

        try {
            let url = `${GET_AM_DASH_BAD_PHONE_NUMBER_COUNT}`;
            const params = new URLSearchParams();
            if (selectedAgency) {
                params.append("agency_ids", selectedAgency);
            }



            if (start_date && end_date) {
                // if (isAllBfiles) {
                //     params.append("start_date", '2010-01-01');
                //     params.append("end_date", '2050-01-01');
                // } 

                params.append("start_date", start_date);
                params.append("end_date", end_date);


            }




            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }

            const [phoneNumberResponse] = await Promise.allSettled([
                axios.get(url),
            ]);


            const bad_phone_number_count =
                phoneNumberResponse.status === "fulfilled"
                    ? phoneNumberResponse.value.data.bad_phone_number_count
                    : 0;

            // Update state with the fetched count
            this.setState({
                badPhoneNumber: bad_phone_number_count || 0,
            });
        } catch (error) {
            console.error("Error fetching appointment or phone number data:", error);
        } finally {
            this.setState({ loadingChart: false });
        }
    };

    resetAgencyFilter = () => {
        // useBoundStore.getState().resetAMDashboardFilter();
        this.setState({ selectedAgency: "" });
        useBoundStore.getState().setFsFilters({ selectedAgency: "" });
    }

    refreshStats = () => {


        //new date picker impl
        let oldestAgencyStartDate, oldestAgencyEndDate;
        let oldestAgency = F.getOldestAgency(this.state.agencies);
        if (oldestAgency) {
            oldestAgencyStartDate = moment(oldestAgency.start_date).format("YYYY-MM-DD");
            oldestAgencyEndDate = moment().format("YYYY-MM-DD");
        } else {
            oldestAgencyStartDate = moment().startOf("month").format("YYYY-MM-DD");
            oldestAgencyEndDate = moment().endOf("month").format("YYYY-MM-DD");
        }
        useBoundStore.getState().setFsFilters({
            datemodified: {
                start_date: oldestAgencyStartDate,
                end_date: oldestAgencyEndDate
            }
        });

        useBoundStore.getState().setAMDashboardFilter({
            agency_id: '',
            datemodified: {
                start_date: oldestAgencyStartDate,
                end_date: oldestAgencyEndDate
            },
            isDateRangeClicked: false
        });

        //commented due to old date picker impl
        // useBoundStore.getState().setFsFilters({
        //     datemodified: {
        //         start_date: "2010-01-01",
        //         end_date: "2050-01-01"
        //     }
        // });

        this.resetAgencyFilter();


        //commented due to old impl
        // let obj = {
        //     start_date: "2010-01-01",
        //     end_date: "2050-01-01",
        //     period: "from_to"
        // }

        //new date picker impl
        let obj = {
            start_date: oldestAgencyStartDate,
            end_date: oldestAgencyEndDate,
            period: "from_to"
        }

        localStorage.setItem('user_t', "");
        localStorage.setItem('filter_lsp', "");
        // localStorage.setItem("dateObj", JSON.stringify(obj))
        localStorage.removeItem("dateObj")
        this.setState({ user_t: "", filter_lsp: "", isAllBfiles: true, ...obj }, () => {
            useBoundStore.getState().setAMDashboardFilter({
                isAllBfiles: true
            })
            setTimeout(async () => {
                await this.call_appointment_count();
                await this.loadCardData();
                await this.loadAMStats();
            }, 200);
        })
    }



    refreshStatsAllBfile = () => {
        useBoundStore.getState().setAMDashboardFilter({
            datemodified: {
                start_date: undefined,
                end_date: undefined
            },
            isDateRangeClicked: false
        });
        //commented old date impl
        // let obj = {
        //     start_date: moment(("2010-01-01")).format("YYYY-MM-DD"),
        //     end_date: moment(("2050-01-01")).format("YYYY-MM-DD"),
        //     period: "from_to"
        // }

        //new date impl
        const oldestAgency = F.getOldestAgency(this.state.agencies);
        let oldestAgencyEndDate, oldestAgencyStartDate;
        if (oldestAgency) {
            oldestAgencyStartDate = moment(oldestAgency.start_date).format("YYYY-MM-DD");
            oldestAgencyEndDate = moment().format("YYYY-MM-DD");
        } else {
            oldestAgencyStartDate = moment().startOf("month").format("YYYY-MM-DD");
            oldestAgencyEndDate = moment().endOf("month").format("YYYY-MM-DD");
        }
        let obj = {
            start_date: moment(oldestAgencyStartDate).format("YYYY-MM-DD"),
            end_date: moment(oldestAgencyEndDate).format("YYYY-MM-DD"),
            period: "from_to"
        }

        localStorage.setItem('user_t', "");
        localStorage.setItem('filter_lsp', "");
        localStorage.setItem("dateObj", JSON.stringify(obj))
        this.setState({ user_t: "", filter_lsp: "", isAllBfiles: true, ...obj }, () => {
            useBoundStore.getState().setAMDashboardFilter({
                // datemodified: {
                //     start_date: oldestAgencyEndDate,
                //     end_date: oldestAgencyEndDate
                // },
                isAllBfiles: true
            })
            setTimeout(async () => {
                await this.call_appointment_count();
                await this.loadCardData();
                await this.loadAMStats();
            }, 200);
        })
    }


    loadCardData = async () => {
        const { start_date, end_date } = this.state;
        this.setState({ loading: true });

        // Same retention pattern as EaDashboards: dateObj survives grid navigation
        const myDateObj = localStorage.getItem("dateObj");
        let parsedDateObj = null;
        try {
            parsedDateObj = myDateObj ? JSON.parse(myDateObj) : null;
        } catch (error) {
            console.error("Error parsing dateObj from localStorage:", error);
        }

        const zustandState = useBoundStore.getState().AMDashboardFilter;
        const dashboardDateFilter = zustandState.datemodified || {};
        const filterStartDate =
            (parsedDateObj && parsedDateObj.start_date) ||
            dashboardDateFilter.start_date ||
            start_date;
        const filterEndDate =
            (parsedDateObj && parsedDateObj.end_date) ||
            dashboardDateFilter.end_date ||
            end_date;
        const hasDateSelection =
            Boolean(parsedDateObj) || Boolean(zustandState.isDateRangeClicked);

        let threeCardParam = "";
        let activeCallParam = "";

        // Helper function to add params correctly
        function addParams(base, params) {
            if (!base) {
                return "?" + params;
            } else {
                return base + "&" + params;
            }
        }

        if (zustandState.agency_id) {
            threeCardParam = addParams(threeCardParam, `agency_ids=${zustandState.agency_id}`);
            activeCallParam = addParams(activeCallParam, `agency_ids=${zustandState.agency_id}`);
        }

        // On page load / reset: current month params.
        // After date picker selection (or return from grid with dateObj): start_date / end_date params.
        if (hasDateSelection && filterStartDate && filterEndDate) {
            threeCardParam = addParams(threeCardParam, `start_date=${filterStartDate}&end_date=${filterEndDate}`);
            activeCallParam = addParams(activeCallParam, `start_date=${filterStartDate}&end_date=${filterEndDate}`);
        } else {
            const current_year = new Date().getFullYear();
            const current_month = new Date().getMonth() + 1;
            threeCardParam = addParams(threeCardParam, `current_year=${current_year}&current_month=${current_month}`);
            activeCallParam = addParams(activeCallParam, `current_year=${current_year}&current_month=${current_month}`);
        }

        // Date picker selected: live stats with date range (for total).
        // Otherwise: monthly live stats + history total from agency_manager_dashboard_history.
        let API_URL_CUSTOM_UPLOAD_LIVE;

        if (hasDateSelection && filterStartDate && filterEndDate) {
            API_URL_CUSTOM_UPLOAD_LIVE = `${CUSTOMER_UPLOAD_LIVE_STAT_TOTAL}?start_date=${filterStartDate}&end_date=${filterEndDate}`;
        } else {
            API_URL_CUSTOM_UPLOAD_LIVE = CUSTOMER_UPLOAD_LIVE_STAT_MONTHLY;
        }

        if (zustandState.agency_id) {
            API_URL_CUSTOM_UPLOAD_LIVE += `&agency_id=${zustandState.agency_id}`;
        }



        try {
            const [fourCardData, activeCalls, customerUploadMonthLiveCount] = await Promise.allSettled([
                axios.get(`${GET_AM_DASH_THREE_CARDS_STAT}${threeCardParam}`),
                axios.get(`${GET_AM_DASH_ACTIVE_CALL_COUNT}${activeCallParam}`),
                axios.get(API_URL_CUSTOM_UPLOAD_LIVE)
            ]);

            const fourCardDataResult = fourCardData.status === 'fulfilled'
                ? fourCardData.value.data
                : {};

            const activeCallsResult = activeCalls.status === 'fulfilled'
                ? activeCalls.value.data
                : {};

            const customerUploadMonthLiveCountResult = customerUploadMonthLiveCount.status === 'fulfilled'
                ? customerUploadMonthLiveCount.value.data
                : {};



            const {
                customer_upload_history_literal = {},
                appointment_history_literal = {},
                not_interested_history_literal = {},
                non_responsive_history_literal = {},
            } = fourCardDataResult;

            const { active_calls_month = {}, active_calls_full = {} } = activeCallsResult;

            const customerUploadLiveLiteral =
                (customerUploadMonthLiveCountResult &&
                    customerUploadMonthLiveCountResult.customer_upload_live_literal) ||
                {};

            const categories = ["review", "lead", "opportunity"];
            const statsMap = {
                review: "Review",
                lead: "Prospect",
                opportunity: "FollowUp",
            };

            const card_data = categories.reduce((acc, category) => {
                const categoryKey = statsMap[category];
                const customerUploadLive = customerUploadLiveLiteral[categoryKey] || [];
                const customerUploadHistory = customer_upload_history_literal[categoryKey] || [];
                const appointmentHistory = appointment_history_literal[categoryKey] || [];
                const notInterestedHistory = not_interested_history_literal[categoryKey] || [];
                const nonResponsiveHistory = non_responsive_history_literal[categoryKey] || [];

                acc[category] = {
                    // Month from live stats; Total from live stats when date picked, else history
                    customer_upload_monthly: customerUploadLive[0] || 0,
                    customer_upload_total: hasDateSelection
                        ? customerUploadLive[0] || 0
                        : customerUploadHistory[0] || 0,
                    schedule_activity_monthly: appointmentHistory[1] || 0,
                    schedule_activity_total: appointmentHistory[0] || 0,
                    active_calls_monthly: active_calls_month[categoryKey] || 0,
                    active_calls_total: active_calls_full[categoryKey] || 0,
                    not_interested_monthly: notInterestedHistory[1] || 0,
                    not_interested_total: notInterestedHistory[0] || 0,
                    non_responsive_monthly: nonResponsiveHistory[1] || 0,
                    non_responsive_total: nonResponsiveHistory[0] || 0,
                };
                return acc;
            }, {});

            // Update state with the fetched data

            this.setState((prevState) => ({
                dashboard: {
                    ...prevState.dashboard,
                    card_data,
                },
            }));
        } catch (error) {
            // Improved error handling with detailed logging
            console.error("Error fetching dashboard card data:", error);
        } finally {
            // Set loading to false after completion
            this.setState({ loading: false });
        }
    };


    loadAMStats = async () => {
        const zustandState = useBoundStore.getState().AMDashboardFilter;
        const {
            period,
            start_date,
            end_date,
            agency_id,
            user_t,
            user,
            filter_lsp,
            dashboard,
        } = this.state;
        let data = { window: period };

        if (start_date != null && end_date != null) {
            data.from = start_date;
            data.to = end_date;
        }

        if (period != null && period != "from_to") {
            const datesData = F.getServerDateByType(period);
            data.from = datesData.from;
            data.to = datesData.to;
        }

        data.agency_id = !zustandState.agency_id ? null : zustandState.agency_id;
        data.all_agency = !zustandState.agency_id ? true : false;


        this.setState({
            loadingStats: true,
        });

        let statsApi = null;

        const dash_stats_am = {
            window: "from_to",
            from: "2010-01-01",
            to: "2050-01-01",
            agency_id: !zustandState.agency_id ? null : zustandState.agency_id,
            all_agency: !zustandState.agency_id ? true : false
        }

        statsApi = axios.post(GET_AM_DASHBOARD_STATS, dash_stats_am);

        let apiUrl = `${GET_AM_DASH_GET_COMPLETED_HISTORY_COUNT}?start_date=${"2010-01-01"}&end_date=${"2050-01-01"}`;

        if (data.agency_id) {
            apiUrl += `&agency_ids=${data.agency_id}`;
        }

        let calculatorResult = axios.get(apiUrl);
        const combinedCountParams = new URLSearchParams();
        if (data.agency_id) combinedCountParams.set("agency_id", data.agency_id);
        const combinedCountUrl = `${COMBINED_COMPLETED_RAC_COUNT}${combinedCountParams.toString() ? `?${combinedCountParams.toString()}` : ""}`;
        const combinedRacCount = axios.post(combinedCountUrl, {
            from: dash_stats_am.from,
            to: dash_stats_am.to,
        });



        try {
            const [statsApiData, calculatorResultData, combinedRacCountData] = await Promise.allSettled([
                statsApi,
                calculatorResult,
                combinedRacCount,
            ]);

            const statsApiResult = statsApiData.status === 'fulfilled' ? statsApiData.value.data : {};
            const calculatorResultDataResult = calculatorResultData.status === 'fulfilled' ? calculatorResultData.value.data : {};
            const combinedRacCountResult = combinedRacCountData.status === 'fulfilled'
                ? F.get_combined_rac_count(combinedRacCountData.value)
                : 0;

            // const presentKey = Object.keys(statsApiResult).find(key =>
            //     ["agency_stats", "stats", "lsp"].includes(key) && statsApiResult[key]
            // );


            let agency_stats = statsApiResult.agency_stats;
            // switch (presentKey) {
            //     case "agency_stats":
            //         let agency_stats = statsApiResult.agency_stats;
            //         break;
            //     case "stats":
            //         agency_stats = statsApiResult.stats;
            //         break;
            //     case "lsp":
            //         agency_stats = this.getCurrentUserStats(user_t, statsApiResult.lsp);
            //         break;
            //     default:
            //         console.log("Invalid key", presentKey);
            // }

            agency_stats = {
                ...agency_stats,
                completed: calculatorResultDataResult.completed_history_by_date_range,
                customer_upload: calculatorResultDataResult.upload_history_by_date_range,
                combined_rac_files_count: combinedRacCountResult,
            };

            const updatedDashboard = {
                ...dashboard,
                stats: agency_stats,
            };

            this.setState((prevState) => ({
                ...prevState,
                dashboard: updatedDashboard,
            }));
        } catch (error) {
            console.error("Error fetching dashboard stats:", error);
        } finally {
            this.setState({ loadingStats: false }); // Set loading to false after completion
        }
    };

    getCurrentUserStats = (user_t, lsp) => {
        const userStats = lsp.find((item) => item.user && item.user.id === parseInt(user_t, 10));
        return userStats && userStats.stats ? userStats.stats : {};
    }

    refresh = async () => {
        await this.loadCardData();
        await this.loadAMStats();
        await this.call_appointment_count();
    };

    handleRoleChange = (newRole) => {

    }


    fetchAllBfiles = async () => {
        this.setState({ isAllBfiles: true }, async () => { // NOSONAR
            useBoundStore.getState().setAMDashboardFilter({
                isAllBfiles: true
            })
            this.refreshStatsAllBfile(); // NOSONAR
        })
    };



    render() {
        const {
            dashboard,
            associations,
            loading,
            loadingChart,
            loadingStats,
            agencyStatsLoading,
            myStatsLoading,
            lspStatsLoading,
            start_date,
            end_date,
            period,
            filter_lsp,
            collapsed,
            user_t,
        } = this.state;

        const user = this.props.auth.user;
        let user_type = user.user_type;
        if (user.user_type === "EA") user_type = "Agency Owner";
        if (user.user_type === "LSP") user_type = "Agency Member";

        const isDashboardHasData =
            dashboard.hasOwnProperty("agency_stats") &&
            dashboard.hasOwnProperty("stats");

        let date_url = "";
        if (period === "from_to") {
            date_url = "?from_to";
        }

        const {
            customer_uploaded,
            completed,
            saved_for_later,
            follow_up,
            total_pnc,
            // life_opportunities,
            umbrella_recommended,
            retirement_uncovered,
            total_assets_uncovered,
            combined_rac_files_count
        } = F.get_ea_stats(dashboard.stats, filter_lsp, user_t);

        let data = {
            customer_uploaded,
            completed,
            saved_for_later,
            follow_up,
            total_pnc,
            // life_opportunities,
            life_opportunities: dashboard.stats.life_opportunities || 0,
            umbrella_recommended,
            retirement_uncovered,
            total_assets_uncovered,
            combined_rac_files_count
        };


        let customer_result = F.get_activity_card_data_agency_manager(data, "", "customer_result").sort((a, b) => a.orderIndex - b.orderIndex) || [];
        const selectedUser = associations.find(user => user.id === parseInt(user_t, 10));


        const handleBadPhoneNumber = () => {
            let datemodified = useBoundStore.getState().fSfilters.datemodified;
            const initialDateRange = {
                start_date: datemodified.start_date || "2010-01-01",
                end_date: datemodified.end_date || "2050-01-01",
            };
            useBoundStore.getState().setFsFilters({ datemodified: initialDateRange, searchText: "", page: 1, filter_by_column_name: {} })
            this.props.history.push(`/newbfiles/bad-phone-numbers?all_bfiles`);
        }


        //commented old date picker impl
        // const selectAgency = async (value) => {
        //     this.setState({ selectedAgency: value });
        //     useBoundStore.getState().setAMDashboardFilter({ agency_id: value });
        //     useBoundStore.getState().setFsFilters({ selectedAgency: value });
        //     if (value) {
        //         await this.fetchAgencyDetails(value);
        //     } else {
        //         this.setState({
        //             vonboard: 1,
        //             review: 1,
        //             active: 1,
        //             is_lead: 1,
        //             show_lead_card_appointment_details: 1,
        //             is_opportunity: 1,
        //             colSpan: 8
        //         });
        //     }

        // }

        //new date picker imple
        const selectAgency = async (value) => {
            const { agencies } = this.state;
            useBoundStore.getState().setAMDashboardFilter({
                agency_id: value
            })

            let start_date, end_date;

            if (value) {
                const selected = agencies.find(a => a.agency_id === value);

                if (selected) {
                    start_date = moment(selected.start_date).format("YYYY-MM-DD");
                    end_date = moment().format("YYYY-MM-DD");
                }
            } else {
                // ✅ fallback when "All Agencies"
                const oldestAgency = F.getOldestAgency(agencies);

                if (oldestAgency) {
                    start_date = moment(oldestAgency.start_date).format("YYYY-MM-DD");
                    end_date = moment().format("YYYY-MM-DD");
                } else {
                    start_date = moment().startOf("month").format("YYYY-MM-DD");
                    end_date = moment().endOf("month").format("YYYY-MM-DD");
                }
            }

            localStorage.setItem(
                'dateObjAgencySelectionAM',
                JSON.stringify({
                    start_date: start_date,
                    endDate: end_date
                })
            )

            this.setState({
                selectedAgency: value,
                start_date,
                end_date
            }, async () => {
                useBoundStore.getState().setAMDashboardFilter({
                    agency_id: value,
                    datemodified: { start_date, end_date }
                });
                useBoundStore.getState().setFsFilters({
                    selectedAgency: value,
                    datemodified: { start_date, end_date }
                });

                if (value) {
                    await this.fetchAgencyDetails(value);
                } else {
                    this.setState({
                        vonboard: 1,
                        review: 1,
                        active: 1,
                        is_lead: 1,
                        show_lead_card_appointment_details: 1,
                        is_opportunity: 1,
                        colSpan: 8
                    });
                }

                // ✅ IMPORTANT: single API trigger after correct dates
                // await this.loadAdditionalData();
            });
        };

        return (
            <div className="eaDashboard">

                {
                    (this.props.auth.user.user_type == AGENCY_MANAGER ||
                    this.props.auth.user.user_type == SUPER_ADMIN)
                    && (
                        <CommonHeader user={this.props.auth.user}
                        onRoleChange={this.handleRoleChange} isHidden={false} />
                    )
                }




                {
                    this.props.auth.user.user_type == AGENCY_MANAGER && (
                        <div className="amdashboard-header-flex">
                            <div className="amdashboard-header-btn-wrap">
                                <Button
                                    shape="round"
                                    type="default"
                                    className="bad_phone_number_am"
                                    onClick={handleBadPhoneNumber}
                                >
                                    <img
                                        id="callicon"
                                        src={BadPhoneNumber}
                                        alt="Bad Phone Number"
                                        width="16px"
                                    />
                                    <span className="text-11">Bad Phone Numbers</span>
                                    <span className="text-11">{this.state.badPhoneNumber}</span>
                                </Button>
                            </div>

                            <div className="amdashboard-responsive-flex">
                                <div className="amdashboard-header-select-wrap">
                                    <Select
                                        allowClear
                                        showSearch
                                        className='custom-select agency-select'
                                        style={{
                                            fontSize: '12px',
                                            backgroundColor: 'white',
                                            borderRadius: '20px',
                                            width: '100%'
                                        }}
                                        placeholder="Search By Agency"
                                        optionFilterProp="children"
                                        onChange={selectAgency}
                                        filterOption={(input, option) => option.props.children.toLowerCase().includes(input.toLowerCase())}
                                        value={this.state.selectedAgency}
                                        getPopupContainer={(trigger) => {
                                            return trigger.parentElement;
                                        }}
                                    >
                                        {this.state.agencies.length > 0 ? (
                                            <Option value="" style={{ fontSize: '12px' }}>
                                                All Agencies
                                            </Option>
                                        ) : (
                                            <Option value="" style={{ fontSize: '12px' }}>
                                                No Agency Assigned
                                            </Option>
                                        )}
                                        {this.state.agencies.map((opt) => (
                                            <Option key={opt.agency_id} value={opt.agency_id} style={{ fontSize: '12px' }}>
                                                {opt.agency_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>

                                <div style={{
                                    width: window.innerWidth <= 768 ? '100%' : 'auto',
                                    marginTop: window.innerWidth <= 576 ? '0' : '-20px'
                                }}>
                                    <EaDateFilter
                                        state={{ ...this.state }}
                                        loadStats={() => Promise.resolve()}
                                        loadCardData={() => this.loadCardData()}
                                        call_appointment_count={() => this.call_appointment_count()}
                                        refreshStats={() => this.refreshStats()}
                                        fetchAllBfiles={() => this.fetchAllBfiles()}
                                        setState={(e, cb) => this.setState(e, () => cb && cb())}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                }






                {!loading ? (
                    <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
                        {/* {this.state.review === 1 && ( */}
                        <Col md={8} span={24}>
                            <UserActivitiesCard
                                refresh={() => this.refresh()}
                                state={{ ...this.state, type_of_call: "Review" }}
                                buttonStyle={{ background: "#57aeff" }}
                                name="Customer Uploaded"
                                appointment_name="Review Appointments Scheduled"
                                activity_name={"Review"}
                                props={this.props}
                            />
                        </Col>
                        {/* )} */}

                        {/* {this.state.show_lead_card_appointment_details === 1 && ( */}
                        <Col md={8} span={24}>
                            <UserActivitiesCard
                                refresh={() => this.refresh()}
                                state={{ ...this.state, type_of_call: "Prospect" }}
                                buttonStyle={{ background: "#219d5c" }}
                                name="Customer Uploaded"
                                activity_name={"Leads"}
                                appointment_name="Lead Appointments Scheduled"
                                props={this.props}

                            />
                        </Col>
                        {/* )} */}


                        {/* {this.state.is_opportunity === 1 && ( */}
                        <Col md={8} span={24}>
                            <UserActivitiesCard
                                refresh={() => this.refresh()}
                                state={{ ...this.state, type_of_call: "FollowUp" }}
                                className={collapsed ? "card_collapsed" : ""}
                                buttonStyle={{ background: "#ffd427" }}
                                name="Customer Uploaded"
                                activity_name={"Opportunities"}
                                appointment_name="Opportunity Appointments Scheduled"
                                props={this.props}

                            />
                        </Col>
                        {/* )} */}
                    </Row>
                ) : (
                    <div
                        style={{
                            marginTop: 20,
                            background: "#FFF",
                            padding: 20,
                        }}
                    >
                        <Skeleton active />
                    </div>
                )}

                {!loadingStats ? (
                    <Card className="custom-card">
                        {/* <div>
                            <EaDateFilter
                                state={{ ...this.state }}
                                loadStats={() => this.loadAMStats()}
                                setState={(e, cb) => this.setState(e, () => cb && cb())}
                            />
                        </div> */}
                        <div className="calculator_result">
                            <div
                                className="activity_name"
                                style={{ position: "absolute", width: "95%", top: "15px" }}
                            >
                                Total Intelligence Link Results
                            </div>
                            {/* <Row gutter={8} className="activity_name_card" style={{ marginTop: 25 }}> */}
                            <div style={{
                                marginTop: 30,
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                            }}>
                                {[
                                    customer_result.slice(0, 1),
                                    customer_result.slice(1, 4),
                                    customer_result.slice(4),
                                ].map((cardRow, rowIndex) => (
                                    <div
                                        key={rowIndex}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "100%",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {cardRow.map((e, index) => (
                                            <Activity_card
                                                key={`${rowIndex}-${index}`}
                                                md={e.md}
                                                link={e.link}
                                                name={e.name}
                                                count={e.count}
                                                img={e.icon || ""}
                                                index={e.index}
                                                props={this.props}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* <div className="calculator_result" style={{ paddingTop: 0 }}>
              <Row gutter={24} className="activity_name_card">
                {bfile_status.map((e, index) => {
                  return (
                    <Activity_card
                      key={index}
                      link={e.link}
                      img={e.icon || ""}
                      name={e.name}
                      count={e.count}
                      md={7}
                    />
                  );
                })}
              </Row>
            </div> */}
                    </Card>
                ) : (
                    <div
                        style={{
                            marginTop: 20,
                            background: "#FFF",
                            padding: 20,
                        }}
                    >
                        <Skeleton active />
                    </div>
                )}
            </div>
        );
    }
}

export default AMDashboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/AMDashboard.js